<template>
  <app-chart chartType="barLine" v-if="chartOptions"
    :chartOptions="chartOptions"
    :height="170">
  </app-chart>
</template>

<script>
import { parse, format } from 'date-fns'
import { getPercentage, thousand } from '@/libs/utils'
import { getTooltipHtml } from '@/libs/chart-helper'
import AppChart from '@/components/chart'

export default {
  name: 'UvAnalytics',
  components: {
    AppChart
  },
  props: [
    'dailyData'
  ],
  computed: {
    chartOptions () {
      const returnUserLabel = this.$t('heatmap.cvr_exit.revisit')
      const newUserLabel = this.$t('heatmap.cvr_exit.new')
      const legendLabels = [returnUserLabel, newUserLabel, 'UV']

      return {
        tooltip: {
          formatter (params) {
            function getItemContent (item, pvItem) {
              let itemContent

              if (pvItem) {
                const percentage = getPercentage(item.value, pvItem.value, 1)
                itemContent = [
                  `${item.marker}${item.seriesName} : ${thousand(item.value)}`,
                  `${percentage}%`
                ]
              } else {
                itemContent = [
                  `${item.marker}${item.seriesName} :`,
                  thousand(item.value)
                ]
              }
              return itemContent
            }
            const returnUserData = params.find(item => item.seriesName === legendLabels[0])
            const newUserData = params.find(item => item.seriesName === legendLabels[1])
            const uvData = params.find(item => item.seriesName === legendLabels[2])
            const content = []

            if (returnUserData) {
              content.push(getItemContent(returnUserData, uvData))
            }
            if (newUserData) {
              content.push(getItemContent(newUserData, uvData))
            }
            if (uvData) {
              content.push(getItemContent(uvData))
            }
            return getTooltipHtml(content, params[0].axisValue)
          }
        },
        xAxis: {
          data: this.dailyData.map(item => format(parse(item.timestamp), 'MM-DD'))
        },
        yAxis: {
          splitNumber: 3
        },
        series: [
          {
            name: legendLabels[0],
            type: 'bar',
            barWidth: 10,
            stack: 'stack-0',
            data: this.dailyData.map(item => item.returnUv),
            itemStyle: {
              barBorderRadius: [0, 0, 5, 5]
            }
          },
          {
            name: legendLabels[1],
            type: 'bar',
            barWidth: 10,
            stack: 'stack-0',
            data: this.dailyData.map(item => item.newUv),
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0]
            }
          },
          {
            name: legendLabels[2],
            type: 'line',
            data: this.dailyData.map(item => item.uv),
            showSymbol: false,
            symbolSize: 2,
            smooth: true
          }
        ],
        color: ['#1199af', '#9fce12', '#43b6c9']
      }
    }
  }
}
</script>

<style>

</style>
